// Module
var code = "<div class=\"form-card\">\n    <div class=\"form-card__title\">{[await values.getTitle()]}</div>\n    <tpl if=\"data.officialTitle\"><span class=\"form-card__official-name\"><span>{data.officialTitle}</span></span></tpl>\n    <tpl if=\"data.description\"><span class=\"form-card__description\">{data.description}</span></tpl>\n</div>\n";
// Exports
module.exports = code;